import { render, staticRenderFns } from "./DashboardCards.vue?vue&type=template&id=00f72382&scoped=true&"
import script from "./DashboardCards.vue?vue&type=script&lang=js&"
export * from "./DashboardCards.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCards.vue?vue&type=style&index=0&id=00f72382&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f72382",
  null
  
)

export default component.exports